export default (state = [], action) => {
  switch (action.type) {
    case "FETCH_BANKSLIPS":
      return action.payload;
    case "CREATE_BANKSLIP":
      return [...state, action.payload];
    case "DELETE_BANKSLIP":
      return state.filter(({ _id }) => _id !== action.payload.payload);
    default:
      return state;
  }
};
